import * as React from 'react';
import { AuthState } from '../auth/auth.types';
import { AdminState } from '../admin/admin.types';
import { ProgramsState } from '../programs/Types';
import { IdleState } from '../idle/Types';
import { Member, PaymentInfo, MembersState, MembersResponseData } from '../members/members.types';
import { BusinessState } from 'src/business/business.types';
import CommonFeatures from '../commons/CommonFeatures';
import TextField from 'material-ui/TextField';
import { overlayStyle, renderOverlayLoading } from '../util/Overlay';
import { dateFromString } from '../util/date-util';
import CheckCircle from 'material-ui/svg-icons/action/check-circle';
import FlatButton from 'material-ui/FlatButton';
import ReactTable from 'react-table';
import RaisedButton from 'material-ui/RaisedButton';
import Dialog from 'material-ui/Dialog';
import {
  cannotWrite,
  cannotUpdate,
  isMemberDisabled,
  isProgramDisabled,
  isPackageDisabled,
  cannotDelete,
  cannotRead
} from '../util/permission.util';
import { mmsStore } from 'src/app/app.config';
import { MEMBER, PAYMENT, MARKETING } from '../account/Constants';
import EmailEditor from 'react-email-editor';
import Checkbox from 'material-ui/Checkbox';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import { EmailTemplateState, EmailTemplatesResponseData, EmailTemplate } from './Types';
import { createEmailTemplate } from './Actions';
import {
  Accordion,
  AccordionItem,
  AccordionItemTitle,
  AccordionItemBody,
} from 'react-accessible-accordion';
import '../payments/payment-list-accordian.css';
// import MaterialTable, { MTableToolbar } from 'material-table';

type Props = {
  readonly authState: AuthState
  readonly adminState: AdminState
  readonly membersState: MembersState
  readonly programsState: ProgramsState
  readonly businessState: BusinessState
  readonly emailTemplateState: EmailTemplateState
  readonly createEmailTemplate: (
    name: string, subject: string, html: string, automated: boolean, event: string,
    days: number, beforeAfter: string, active: boolean, content: string
  ) => Promise<EmailTemplatesResponseData>
  readonly getEmailTemplates: () => Promise<EmailTemplatesResponseData>
  readonly deleteEmailTemplate: (id: number) => Promise<EmailTemplatesResponseData>
  readonly updateEmailTemplate: (
    id: number, name: string, subject: string, html: string, automated: boolean, event: string,
    days: number, beforeAfter: string, active: boolean, content: string
  ) => Promise<EmailTemplatesResponseData>
};
type States = {
  readonly displayDetailPage: boolean
  readonly name: string
  readonly subject: string
  readonly html: string
  readonly automated: boolean
  readonly active: boolean
  readonly event: string
  readonly days: number
  readonly beforeAfter: string
  readonly content: string
  readonly selectedEmailTemplate: EmailTemplate
  readonly openDeleteWarning: boolean
  readonly nameError: string
  readonly subjectError: string
};

class EmailTemplateComponent extends React.Component<Props, States> {
  emailEditor: any;

  constructor(props: Props) {
    super(props);
    this.state = {
      displayDetailPage: false,
      name: undefined,
      subject: undefined,
      html: undefined,
      automated: false,
      active: false,
      event: 'birthDay',
      days: 0,
      beforeAfter: 'before',
      content: undefined,
      selectedEmailTemplate: undefined,
      openDeleteWarning: false,
      nameError: '',
      subjectError: ''
    };
  }

  componentDidMount() {
    this.props.getEmailTemplates();
  }

  render() {

    const {
      authState,
      adminState
    } = this.props;

    const {
      displayDetailPage
    } = this.state;

    return (
      <CommonFeatures
        authState={this.props.authState}
        businessState={this.props.businessState}
      >
        <div className="page-header-row row mt-2 mb-3">
          <div className="col-auto">
            <h3>Email Template</h3>
          </div>
        </div>
        {
          displayDetailPage ?
            this.renderDetailPage()
            : this.renderListPage()
        }
        {
          this.renderDeleteWarningModal()
        }
      </CommonFeatures>
    );
  }

  private renderDetailPage = (): JSX.Element => {
    const {
      authState,
      adminState
    } = this.props;
    const {
      name, subject
    } = this.state;
    var emailEditor = editor => {
      if (!this.emailEditor) {
        this.emailEditor = editor;
      }
    };
    return (
      <div className="container mx-1" style={{ maxWidth: '100%' }}>
        <div className="row">
          <div className="col">
            <div className="row mx-1" style={{ width: '50%' }}>
              <TextField
                floatingLabelText="Name"
                floatingLabelFixed={true}
                fullWidth={true}
                value={this.state.name}
                onChange={this.onNameChange}
                errorText={this.state.nameError}
              />
            </div>
            <div className="row mx-1" style={{ width: '50%' }}>
              <TextField
                floatingLabelText="Subject"
                floatingLabelFixed={true}
                fullWidth={true}
                value={this.state.subject}
                onChange={this.onSubjectChange}
                errorText={this.state.subjectError}
              />
            </div>
            <div className="row mx-1 my-3">
              <Checkbox
                label="Automated Email"
                checked={this.state.automated}
                onCheck={() => this.setState({ automated: !this.state.automated })}
              />
              {
                this.state.automated ? this.renderAutomatedOptions() : null
              }
            </div>
            <div className="row mx-1">
              <p>Body</p>
            </div>
            <div className="mb-1">
              <Accordion accordion={false}>
                <AccordionItem expanded={true}>
                  <AccordionItemTitle>
                    <h6 className="u-position-relative">
                      <b>Personalizing Options</b>
                      <div className="accordion__arrow" role="presentation" />
                    </h6>
                  </AccordionItemTitle>
                  <AccordionItemBody>
                    <table style={{ width: '100%' }}>
                      <thead>
                        <tr>
                          <th>Option</th>
                          <th>Value</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Member Name</td>
                          <td>{'{MEMBER_NAME}'}</td>
                        </tr>
                        <tr>
                          <td>Birth Date</td>
                          <td>{'{BIRTH_DATE}'}</td>
                        </tr>
                        <tr>
                          <td>Start Date</td>
                          <td>{'{START_DATE}'}</td>
                        </tr>
                        <tr>
                          <td>End Date</td>
                          <td>{'{END_DATE}'}</td>
                        </tr>
                        <tr>
                          <td>Point</td>
                          <td>{'{POINT}'}</td>
                        </tr>
                      </tbody>
                    </table>
                  </AccordionItemBody>
                </AccordionItem>
              </Accordion>
            </div>
            <div className="row mx-1">
              <EmailEditor
                style={{ width: '100' }}
                minHeight={600}
                ref={emailEditor}
                onLoad={this.loadEmailTemplate}
              />
            </div>
            <div className="row mx-1 fr">
              <RaisedButton
                className="my-3 mr-1"
                label="SAVE"
                fullWidth={false}
                primary={true}
                onClick={this.saveEmailTemplate}
                disabled={this.validateInputs(true)}
                style={{ paddingRight: 0 }}
              />
              {
                this.state.selectedEmailTemplate ?
                  <div>
                    <RaisedButton
                      className="my-3 mx-1"
                      label="COPY"
                      fullWidth={false}
                      secondary={true}
                      onClick={this.copyEmailTemplate}
                      disabled={this.validateInputs(false)}
                      style={{ paddingRight: 0 }}
                    />
                    <RaisedButton
                      className="my-3 mx-1"
                      label="DELETE"
                      fullWidth={false}
                      secondary={true}
                      onClick={() => this.setState({ openDeleteWarning: true })}
                      disabled={cannotDelete(MARKETING, authState, adminState)}
                      style={{ paddingRight: 0 }}
                    />
                  </div>
                  :
                  null
              }
              <RaisedButton
                className="my-3 ml-1"
                label="CANCEL"
                fullWidth={false}
                secondary={true}
                onClick={this.cancel}
                style={{ paddingRight: 0 }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  private validateInputs = (update: boolean): boolean => {
    const {
      authState,
      adminState
    } = this.props;
    const {
      name, subject
    } = this.state;
    if (update) {
      return (name === undefined) || (subject === undefined) ||
        (name === '') || (subject === '') ||
        cannotUpdate(MARKETING, authState, adminState);
    } else {
      return (name === undefined) || (subject === undefined) ||
        (name === '') || (subject === '') ||
        cannotWrite(MARKETING, authState, adminState);
    }
  }

  private renderAutomatedOptions = (): JSX.Element => {
    return (
      <div className="container mx-1">
        <div className="row">
          <div className="col">
            <Checkbox
              label="Active"
              checked={this.state.active}
              onCheck={() => this.setState({ active: !this.state.active })}
            />
          </div>
        </div>
        <div className="row">
          <div className="col">
            <div style={{ width: '50%' }}>
              <SelectField
                fullWidth={true}
                floatingLabelText="Event"
                value={this.state.event}
                onChange={this.onEventChange}
              >
                <MenuItem value={'birthDay'} primaryText={'Birth Day'} />
                <MenuItem value={'expiryDay'} primaryText={'Expiry Day'} />
              </SelectField>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <div className="row mx-1">
              <div className="mr-2" style={{ width: '25%' }}>
                <SelectField
                  fullWidth={true}
                  floatingLabelText="Before/After"
                  value={this.state.beforeAfter}
                  onChange={this.onBeforeAfterChange}
                >
                  <MenuItem value={'before'} primaryText={'Before'} />
                  <MenuItem value={'after'} primaryText={'After'} />
                </SelectField>
              </div>
              <div className="ml-2" style={{ width: '25%' }}>
                <TextField
                  hintText="Days"
                  floatingLabelText="Days"
                  value={this.state.days}
                  onChange={this.onWhenChange}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

    );
  }

  private onNameChange = (
    event: React.FormEvent<HTMLInputElement>, newValue: string
  ): void => {
    if (newValue === '') {
      this.setState({
        nameError: 'Name cannot be empty.',
        name: newValue
      });
    } else {
      this.setState({ name: newValue });
    }
  }

  private onSubjectChange = (
    event: React.FormEvent<HTMLInputElement>, newValue: string
  ): void => {
    if (newValue === '') {
      this.setState({
        subjectError: 'Subject cannot be empty.',
        subject: newValue
      });
    } else {
      this.setState({ subject: newValue });
    }

  }

  private onEventChange = (
    event: React.TouchEvent<HTMLSelectElement>, index: number, value: string
  ): void => {
    this.setState({ event: value });
  }

  private onBeforeAfterChange = (
    event: React.TouchEvent<HTMLSelectElement>, index: number, value: string
  ): void => {
    this.setState({ beforeAfter: value });
  }

  private onWhenChange = (event: React.FormEvent<HTMLInputElement>, newValue: string): void =>
    this.setState({ days: isNaN(parseInt(newValue, 10)) ? 0 : parseInt(newValue, 10) })

  private saveEmailTemplate = () => {
    const {
      name, subject, automated, event, days, beforeAfter, selectedEmailTemplate, active
    } = this.state;
    this.emailEditor.exportHtml(data => {
      const { design, html } = data;
      if (selectedEmailTemplate) {
        this.props.updateEmailTemplate(selectedEmailTemplate.id, name, subject, html, automated,
          automated ? event : undefined, automated ? days : undefined, automated ? beforeAfter : undefined,
          automated ? active : false,
          JSON.stringify(design)).then(res => {
            switch (this.props.emailTemplateState.statusCode) {
              case 200:
                return this.setState({
                  name: undefined,
                  subject: undefined,
                  content: undefined,
                  html: undefined,
                  beforeAfter: undefined,
                  days: undefined,
                  automated: false,
                  active: false,
                  displayDetailPage: false
                });
              default:
                return this.setState({
                  name: undefined,
                  subject: undefined,
                  content: undefined,
                  html: undefined,
                  beforeAfter: undefined,
                  days: undefined,
                  automated: false,
                  active: false,
                  displayDetailPage: false
                });
            }
          });
      } else {
        this.props.createEmailTemplate(name, subject, html, automated,
          automated ? event : undefined, automated ? days : undefined, automated ? beforeAfter : undefined,
          automated ? active : false,
          JSON.stringify(design)).then(res => {
            switch (this.props.emailTemplateState.statusCode) {
              case 200:
                return this.setState({
                  name: undefined,
                  subject: undefined,
                  content: undefined,
                  html: undefined,
                  beforeAfter: undefined,
                  days: undefined,
                  automated: false,
                  active: false,
                  displayDetailPage: false
                });
              default:
                return this.setState({
                  name: undefined,
                  subject: undefined,
                  content: undefined,
                  html: undefined,
                  beforeAfter: undefined,
                  days: undefined,
                  automated: false,
                  active: false,
                  displayDetailPage: false
                });
            }
          });
      }
    });
  }

  private copyEmailTemplate = () => {
    const {
      name, subject, automated, event, days, beforeAfter, selectedEmailTemplate, active
    } = this.state;
    this.emailEditor.exportHtml(data => {
      const { design, html } = data;
      this.props.updateEmailTemplate(selectedEmailTemplate.id, name, subject, html, automated,
        event, days, beforeAfter, active, JSON.stringify(design)).then(res => {
          switch (this.props.emailTemplateState.statusCode) {
            case 200:
              this.props.createEmailTemplate(selectedEmailTemplate.name + ' - Copy',
                selectedEmailTemplate.subject + ' - Copy',
                html, automated,
                event, days, beforeAfter, active, JSON.stringify(design)).then(
                  response => {
                    switch (this.props.emailTemplateState.statusCode) {
                      case 200:
                        return this.setState({
                          name: undefined,
                          subject: undefined,
                          content: undefined,
                          html: undefined,
                          beforeAfter: undefined,
                          days: undefined,
                          automated: false,
                          displayDetailPage: false
                        });
                      default:
                        return this.setState({
                          name: undefined,
                          subject: undefined,
                          content: undefined,
                          html: undefined,
                          beforeAfter: undefined,
                          days: undefined,
                          automated: false,
                          displayDetailPage: false
                        });
                    }
                  }
                );
              break;
            default:
              return this.setState({
                name: undefined,
                subject: undefined,
                content: undefined,
                html: undefined,
                beforeAfter: undefined,
                days: undefined,
                automated: false,
                displayDetailPage: false
              });
          }
        });
    });
  }

  private deleteEmailTemplate = () => {
    const {
      selectedEmailTemplate, openDeleteWarning
    } = this.state;
    this.props.deleteEmailTemplate(selectedEmailTemplate.id).then(
      res => {
        switch (this.props.emailTemplateState.statusCode) {
          case 200:
            return this.setState({
              name: undefined,
              subject: undefined,
              content: undefined,
              html: undefined,
              beforeAfter: undefined,
              days: undefined,
              automated: false,
              active: false,
              selectedEmailTemplate: undefined,
              displayDetailPage: false,
              openDeleteWarning: false
            });
          default:
            return this.setState({
              name: undefined,
              subject: undefined,
              content: undefined,
              html: undefined,
              beforeAfter: undefined,
              days: undefined,
              automated: false,
              active: false,
              selectedEmailTemplate: undefined,
              displayDetailPage: false,
              openDeleteWarning: false
            });
        }
      }
    );
  }

  private loadEmailTemplate = () => {
    const {
      content, selectedEmailTemplate
    } = this.state;
    if (selectedEmailTemplate && this.emailEditor) {
      this.emailEditor.loadDesign(JSON.parse(content));
    } else if (selectedEmailTemplate && !this.emailEditor) {
      this.setState({
        name: undefined,
        subject: undefined,
        content: undefined,
        html: undefined,
        beforeAfter: undefined,
        days: undefined,
        automated: false,
        active: false,
        selectedEmailTemplate: undefined,
        displayDetailPage: false
      });
    }
  }

  private cancel = () => {
    this.setState(
      {
        name: undefined,
        subject: undefined,
        content: undefined,
        html: undefined,
        beforeAfter: undefined,
        days: undefined,
        automated: false,
        active: false,
        selectedEmailTemplate: undefined,
        displayDetailPage: false
      }
    );
  }

  private renderListPage = (): JSX.Element => {
    const {
      authState,
      adminState
    } = this.props;
    return (
      <div>
        <RaisedButton
          className="mb3"
          label="CREATE"
          fullWidth={false}
          primary={true}
          onClick={() => this.setState({ displayDetailPage: true })}
          disabled={cannotWrite(MARKETING, authState, adminState)}
          style={{ paddingRight: 0 }}
        />
        <ReactTable
          data={this.generateEmailTemplateTableData()}
          columns={[
            {
              Header: 'Name',
              accessor: 'name',
              style: { textAlign: 'center' }
            },
            {
              Header: 'Subject',
              accessor: 'subject',
              style: { textAlign: 'center' }
            },
            {
              Header: 'Automated',
              accessor: 'automated',
              style: { textAlign: 'center' }
            },
            {
              Header: 'Active',
              accessor: 'active',
              style: { textAlign: 'center' }
            }
          ]
          }
          defaultPageSize={20}
          className="-striped -highlight"
          getTdProps={(state, rowInfo, column, instance) => {
            return {
              onClick: (e, handleOriginal) => rowInfo && !cannotRead(MARKETING, authState, adminState)
                ? this.handleCellClick(rowInfo.index) : null
            };
          }}
        />
      </div>
    );
  }

  private handleCellClick = (index) => {
    const emailTemplate = this.props.emailTemplateState.emailTemplates[index];
    this.setState(
      {
        selectedEmailTemplate: emailTemplate,
        name: emailTemplate.name,
        subject: emailTemplate.subject,
        html: emailTemplate.html,
        automated: emailTemplate.automated,
        event: emailTemplate.event,
        content: emailTemplate.content,
        beforeAfter: emailTemplate.beforeAfter,
        days: emailTemplate.days,
        active: emailTemplate.active,
        displayDetailPage: true
      }
    );
  }

  private generateEmailTemplateTableData = () => {
    const { emailTemplateState } = this.props;
    return emailTemplateState.emailTemplates.map((e: EmailTemplate) => {
      return {
        name: e.name,
        subject: e.subject,
        automated: e.automated ? 'YES' : 'NO',
        active: e.active ? 'YES' : 'NO'
      };
    });
  }

  private renderDeleteWarningModal = (): JSX.Element => {
    return (
      <Dialog
        title="Warning"
        actions={[
          this.renderNoButton(),
          this.renderYesButton()
        ]}
        open={this.state.openDeleteWarning}
        autoScrollBodyContent={true}
        repositionOnUpdate={false}
        onRequestClose={() => this.setState({ openDeleteWarning: false })}
      >
        {
          <b>
            Do you really want to delete the package?
          </b>
        }
      </Dialog>
    );
  }

  private renderNoButton = (): JSX.Element => {
    return (
      <RaisedButton
        label={'NO'}
        secondary={true}
        onClick={() => this.setState({ openDeleteWarning: false })}
      />
    );
  }

  private renderYesButton = (): JSX.Element => {
    return (
      <RaisedButton
        label={'YES'}
        onClick={() => this.deleteEmailTemplate()}
      />
    );
  }

  private renderUpdateButton = (cellInfo) => {
    return (
      <FlatButton
        icon={<CheckCircle />}
      />
    );
  }
}

export default EmailTemplateComponent;


// WEBPACK FOOTER //
// ./src/emailTemplate/EmailTemplateComponent.tsx